// @ts-strict-ignore
import sw from '@u/switch'
import * as act from '@r/reviews/reviews-actions'

export default (state = {}, { type, payload }) =>
  sw({
    [act.SET_REVIEWS]: (reviews: any[]) => ({ ...state, reviews }),
    [act.SET_INCLUDES]: (includes: any) => ({ ...state, includes }),
    default: state,
  })(type, payload)
